import React from 'react'
import StaffUpdate from '../staff_components/staff_update'

export default function StaffUpdatePage() {
  return (
    <div className="content-wrapper" style={{ marginLeft: 0 }}>
      <StaffUpdate />
    </div>
  )
}
